import { GET_TERMINAL_BY_ID } from "./../graphql/queries/getTerminalById"
import { useQuery, useLazyQuery } from "@apollo/client"
import { RESOLUTIONS } from "../utils/chart-helpers"

export const useTerminalById = (id: number, resolution: string, from: any, to: any) => {
  const { data, error, loading, refetch } = useQuery(GET_TERMINAL_BY_ID, {
    variables: {
      id: id,
      resolution: resolution,
      fromTimeStamp: from,
      toTimeStamp: to,
    },
  })
  return { terminal: data?.apiTerminal, error, loading, refetch }
}

export const lazyUseTerminalById = (id: number, resolution: string, from: any, to: any) => {
  const testId = 2
  const testRes = RESOLUTIONS.month
  const testFrom = "2022-08-01T11:35:00+00:00Z"
  const testTo = "2022-09-01T11:35:00+00:00Z"
  const [getTerminalById, { data, error, loading, refetch }] = useLazyQuery(GET_TERMINAL_BY_ID, {
    variables: {
      id: id,
      resolution: resolution,
      fromTimeStamp: from,
      toTimeStamp: to,
    },
  })
  return {
    getTerminalById,
    lazyTerminal: data?.apiTerminal,
    error,
    loading,
    refetch,
  }
}
